"use client";
import { DonatePaperForm } from "components/forms/DonatePaperForm";
import { Container } from "components/layout/Container";
import { useState } from "react";
import st from "@/styles/modules/typography.module.scss";
import s from "./SectionDonatePaperForm.module.scss";
import { UploadResultMessage } from "./UploadResultMessage";
import cn from "classnames";

export const SectionDonatePaperForm = () => {
  const [isSuccess, setSuccess] = useState<boolean | undefined>();

  return (
    <Container className={s.container}>
      <div className={cn(st.card, s.inner)}>
        {(typeof isSuccess !== "boolean" || isSuccess) && isSuccess ? (
          <UploadResultMessage
            heading="Your file was successfully uploaded"
            buttonText="Upload more"
            onClick={() => {
              setSuccess(undefined);
            }}
            success
          />
        ) : (
          <div
            className={cn(s.form, {
              [s.isHidden]: typeof isSuccess === "boolean",
            })}
          >
            <DonatePaperForm setSuccess={setSuccess} />
          </div>
        )}
        {typeof isSuccess === "boolean" && !isSuccess && (
          <UploadResultMessage
            heading="Upload failed"
            subheading="Sorry! Something went wrong."
            buttonText="Try again"
            onClick={() => {
              setSuccess(undefined);
            }}
            success={false}
          />
        )}
      </div>
    </Container>
  );
};
